import { PAGE_SIZE_OPTIONS, ALL_PAGE_SIZE } from '../../hooks/usePageSize';

interface PageSizeSelectProps {
  value: number;
  onChange: (size: number) => void;
  className?: string;
  /** Per-screen size choices; defaults to the shared PAGE_SIZE_OPTIONS. */
  options?: readonly number[];
}

function label(n: number): string {
  return n >= ALL_PAGE_SIZE ? `All (max ${ALL_PAGE_SIZE})` : String(n);
}

/**
 * Rows-per-page selector for admin list screens. Pairs with usePageSize so the
 * choice is saved per user.
 */
export function PageSizeSelect({ value, onChange, className = '', options = PAGE_SIZE_OPTIONS }: PageSizeSelectProps) {
  // A stored per-user preference may not be among this screen's options; show
  // it anyway so the select doesn't silently display the wrong value.
  const values = options.includes(value) ? options : [...options, value].sort((a, b) => a - b);
  return (
    <label className={`flex items-center gap-2 text-sm text-slate-400 ${className}`}>
      <span className="whitespace-nowrap">Per page</span>
      <select
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="px-2 py-1.5 bg-slate-800/50 border border-slate-700 rounded-lg text-white text-sm focus:border-cyan-500 focus:outline-none"
      >
        {values.map((n) => (
          <option key={n} value={n}>{label(n)}</option>
        ))}
      </select>
    </label>
  );
}

export default PageSizeSelect;
